import { useEffect, useState, useMemo } from "react"
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import StatCard from "./Card";
import LoadingModal from "./Unit/LoadingModal";
import { CheckSquare, Users, Clock, Building2, Earth, Calendar, BellPlus, ConciergeBell, ScanEye, Eye, Calendars, Monitor, Smartphone, Globe, Cog, ArrowBigUp, LucideArrowDown, LucideArrowUp, LucideCalendarClock } from "lucide-react";
import ReactTooltip from 'react-tooltip';
import styles from "./index.module.css";
import stylesReport from "./report.module.css";
import { CurrencyConverter } from "./Unit/CurrencyConverter";
import  useCurrencyRate  from "./Unit/useCurrencyRate";
import { set } from "mongoose";
export default function MarketAnalytic() {
     const [data, setData] = useState({
    "success": true,
    "total": 20,
    "hotels": [
        {
            "hotelName": "Hanoi Silk Classy Hotel & Travel",
            "address": "4b Phố Lương Ngọc Quyến",
            "price": 644318.1818,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 8.6,
            "distance": "1.87",
            "distanceToCC": "0.80",
            "url": "https://www.booking.com/hotel/vn/cat-amp-laundry.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "00:00",
            "reviewText": "Excellent"
        },
        {
            "hotelName": "Alley",
            "address": "73 Phố Tôn Thất Thiệp",
            "price": 659259.2593,
            "hotelType": "Apartment",
            "breakfast": true,
            "review": 9.3,
            "distance": "1.45",
            "distanceToCC": "1.05",
            "url": "https://www.booking.com/hotel/vn/alley-ha-noi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "07:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Hanoi Solo Hostel",
            "address": "35 Ma May Str",
            "price": 660000,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 8.3,
            "distance": "1.97",
            "distanceToCC": "0.90",
            "url": "https://www.booking.com/hotel/vn/maison-d-39-hanoi-boutique.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Very Good"
        },
        {
            "hotelName": "HoLo Central Hanoi - Serviced HomeStay",
            "address": "7 Phố Bùi Thị Xuân",
            "price": 666654.6296,
            "hotelType": "Condo Hotel",
            "breakfast": false,
            "review": 9.1,
            "distance": "0.02",
            "distanceToCC": "1.10",
            "url": "https://www.booking.com/hotel/vn/holo-central-hanoi-hai-ba-trung14.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "00:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Sunrise Hanoi Hotel",
            "address": "716 Bach Dang, Hai Ba Trung District",
            "price": 666666.6667,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 8.2,
            "distance": "1.83",
            "distanceToCC": "2.30",
            "url": "https://www.booking.com/hotel/vn/sunrise-hanoi-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Very Good"
        },
        {
            "hotelName": "La Madera Hotel & Spa",
            "address": "18 Cau Go",
            "price": 670833.3334,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 9,
            "distance": "1.61",
            "distanceToCC": "0.55",
            "url": "https://www.booking.com/hotel/vn/violet-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Kingdom Hotel Hanoi",
            "address": "64 Phố Đào Duy Từ",
            "price": 708333.3333,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 8.9,
            "distance": "1.91",
            "distanceToCC": "0.85",
            "url": "https://www.booking.com/hotel/vn/kingdom-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "11:00",
            "reviewText": "Excellent"
        },
        {
            "hotelName": "Midori Boutique Hotel",
            "address": "43 Trieu Viet Vuong Street",
            "price": 736666.6667,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 9.5,
            "distance": "0.21",
            "distanceToCC": "1.30",
            "url": "https://www.booking.com/hotel/vn/santa-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Exceptional"
        },
        {
            "hotelName": "Hanoi Siva Luxury Hotel & Travel",
            "address": "31 Hang Ga, Hoan Kiem",
            "price": 777777.7778,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 8.9,
            "distance": "1.96",
            "distanceToCC": "1.05",
            "url": "https://www.booking.com/hotel/vn/nova-luxury-hotel.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Excellent"
        },
        {
            "hotelName": "Eliana Ruby Hotel & Travel",
            "address": "3 Yen Thai Street",
            "price": 793333.3334,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.5,
            "distance": "1.54",
            "distanceToCC": "0.65",
            "url": "https://www.booking.com/hotel/vn/hanoi-elegance-4.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Exceptional"
        },
        {
            "hotelName": "Hanoi TrangTrang Hotel",
            "address": "15 Phố Cầu Gỗ",
            "price": 808181.8182,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.3,
            "distance": "1.59",
            "distanceToCC": "0.50",
            "url": "https://www.booking.com/hotel/vn/hanoi-mitra.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "11:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Vista Hanoi Hotel",
            "address": "58 Triệu Việt Vương, Phường Hai Bà Trưng, TP. Hà Nội",
            "price": 833333.3333,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9,
            "distance": "0.19",
            "distanceToCC": "1.30",
            "url": "https://www.booking.com/hotel/vn/hanoi-vista.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Lotusama Central Hanoi Hotel",
            "address": "37 Phố Hàng Gà",
            "price": 846296.2963,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.3,
            "distance": "1.94",
            "distanceToCC": "1.05",
            "url": "https://www.booking.com/hotel/vn/lotusama-central-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "10:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Stella Hotel Hà Nội",
            "address": "36B Phố Hàng Tre 22",
            "price": 872727.2727,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 10,
            "distance": "1.63",
            "distanceToCC": "0.60",
            "url": "https://www.booking.com/hotel/vn/dinnh-ha-noi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "05:00",
            "reviewText": "Exceptional"
        },
        {
            "hotelName": "Ritana Boutique Hotel & Spa",
            "address": "4 Phố Thi Sách 1",
            "price": 875001.8182,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.4,
            "distance": "0.42",
            "distanceToCC": "1.20",
            "url": "https://www.booking.com/hotel/vn/ritana-boutique-amp-spa.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "00:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "TrangTrang Luxury Hotel",
            "address": "15 Phố Hàng Dầu",
            "price": 950481.4815,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 9,
            "distance": "1.54",
            "distanceToCC": "0.45",
            "url": "https://www.booking.com/hotel/vn/trangtrang-luxury.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "11:00",
            "reviewText": "Wonderful"
        },
        {
            "hotelName": "Nesta Apartment 13 Bui Thi Xuan",
            "address": "13 Phố Bùi Thị Xuân 6",
            "price": 1042083.3333,
            "hotelType": "Apartment",
            "breakfast": true,
            "review": 7.4,
            "distance": "0.01",
            "distanceToCC": "1.15",
            "url": "https://www.booking.com/hotel/vn/nesta-serviced-apartment-ha-noi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "05:00",
            "reviewText": "Good"
        },
        {
            "hotelName": "Serene Central Hotel",
            "address": "106 Hàng Bông, Hoàn Kiếm, Hanoi",
            "price": 1066666.6667,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.6,
            "distance": "1.35",
            "distanceToCC": "0.70",
            "url": "https://www.booking.com/hotel/vn/hanz-hanoi-de-maison-grand-hanoi.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "11:30",
            "reviewText": "Exceptional"
        },
        {
            "hotelName": "Elegance Premium Hotel",
            "address": "21-23 P. Bát Đàn",
            "price": 1126666.6667,
            "hotelType": "Hotel",
            "breakfast": true,
            "review": 8.4,
            "distance": "1.74",
            "distanceToCC": "0.85",
            "url": "https://www.booking.com/hotel/vn/elegance-premium.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "00:00",
            "reviewText": "Very Good"
        },
        {
            "hotelName": "Calile Hotel - Hanoi Train Street",
            "address": "51A/38A Tran Phu, Ba Dinh",
            "price": 1271996.2963,
            "hotelType": "Hotel",
            "breakfast": false,
            "review": 9.6,
            "distance": "1.65",
            "distanceToCC": "1.15",
            "url": "https://www.booking.com/hotel/vn/tamundi-home-the-old-quarter-ngo-huyen.html",
            "beach": 0,
            "checkin": "14:00",
            "checkout": "",
            "reviewText": "Exceptional"
        }
    ],
    "averagePrice": 863719,
    "lowestPrice": 644318.1818,
    "highestPrice": 1271996.2963
});
     console.log("🚀 ~ MarketAnalytic ~ data:", data)
     const [orderBy, setOrderBy] = useState('price');
     const [offset, setOffset] = useState(0);
     const [branchLocation, setBranchLocation] = useState('20.9732,21.0632,105.7959,105.9039')
     const {t} = useTranslation()
     const [sortData, setSortData] = useState([]);
     const [isLoading, setIsLoading] = useState(false)
     const [currency, setCurrency] = useState("VND");
      const { usdRate, timeLastUpdated } = useCurrencyRate();
     const [startDate, setStartDate] = useState(() =>
        dayjs().format("YYYY-MM-DD")
      );
      const [endDate, setEndDate] = useState(() =>
        dayjs().add(1, 'day').format("YYYY-MM-DD")
      );
        const hotelBbox = [
          {
            name: "Azumaya Hai Ba Trung 1",
            bbox: "20.9732,21.0632,105.7959,105.9039",
          },
          {
            name: "Azumaya Kim Ma 2",
            bbox: "20.9834,21.0734,105.7563,105.8643",
          },
          {
            name: "Azumaya Kim Ma 3",
            bbox: "20.9820,21.0720,105.7561,105.8641",
          },
          {
            name: "Azumaya Ling Lang",
            bbox: "20.9913,21.0813,105.7565,105.8645",
          },
          {
            name: "Azumaya Dao Tan",
            bbox: "20.9885,21.0785,105.7530,105.8608",
          },
          {
            name: "Azumaya Hai Phong",
            bbox: "20.7864,20.8764,106.6426,106.7506",
          },
          {
            name: "Azumaya Da Nang",
            bbox: "16.0409,16.1309,108.1610,108.2690",
          },
          {
            name: "Azumaya Thai Van Lung 1",
            bbox: "10.7345,10.8245,106.6506,106.7586",
          },
          {
            name: "Azumaya Thai Van Lung 2",
            bbox: "10.7343,10.8243,106.6502,106.7582",
          },
          {
            name: "Azumaya Le Thanh Ton",
            bbox: "10.7357,10.8257,106.6510,106.7590",
          },
          {
            name: "Azumaya Annex",
            bbox: "10.7345,10.8245,106.6507,106.7587",
          },
          {
            name: "Azumaya Phnom Penh",
            bbox: "11.5137,11.6037,104.8663,104.9743",
          }
        ];
        const hotelOrder = [
          {
            name: "Price",
            value: "price",
          },
          // {
          //   name: "Price Descend",
          //   value: "price_desc",
          // },
          // {
          //   name: "Popularity",
          //   value: "popularity",
          // },
          {
            name: "Review",
            value: "bayesian_review_score",
          },
          // {
          //   name: "Distance",
          //   value: "distance_from_search",
          // },
          
        ];
       
const sortedHotels = (type) => {

  if(!Array.isArray(data?.hotels))
    return [];

  return data?.hotels.sort((a, b) => {

    switch(type){

      case 'price':

        return (
          (a.price || 0) -
          (b.price || 0)
        );

      case 'review':

        return (
          (b.review || 0) -
          (a.review || 0)
        );

      default:
        return 0;
    }
  });
};
useEffect(() => {
  const sort = sortedHotels(orderBy)
  setSortData(sort)
}, [data])
  const isPhnomPenh =
    branchLocation === "11.5137,11.6037,104.8663,104.9743";
  const currencyAPI = isPhnomPenh ? "USD" : "VND";
 const getMarketData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/market/data/${branchLocation}/${offset}/${currencyAPI}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setData(responseData)
      }

    } 
    catch (error) {
      console.error('Error:', error);
      setIsLoading(false) 
  }
}; 

// useEffect(() => {
 

//   const newCurrency = isPhnomPenh ? "USD" : "VND";

//   setCurrency(newCurrency);
//   setCurrencyAPI(newCurrency);
// }, [branchLocation]);

useEffect(() => {
  if (!startDate || !endDate || !currencyAPI) return;

  getMarketData();
}, [startDate, endDate, branchLocation, offset, currencyAPI]);


    return (
      <div style={{marginBottom: 40}}>
   <div style={{ background: '#fff', color: '#222' }}> 
        <div style={{ padding: 30, paddingBottom: 0, backgroundColor:"#fff" }}>
           <div className="d-flex justify-content-between align-items-center mt-5">
             <div className="d-flex">
                <div style={{marginRight: 10, width: 'fit-content'}}>
                      <Flatpickr 
                        value={startDate}
                          options={{
                          dateFormat:'Y-m-d'}} 
                           className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                            placeholder={t('booking.date_in')} 
                            onChange={(dates)=>{
                            setStartDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                         }} />
                </div>
                  <div style={{marginRight: 10, width: 'fit-content'}}>
                       <Flatpickr 
                               value={endDate}
                               options={{
                                 minDate: dayjs(startDate).format("YYYY-MM-DD"),
                                 dateFormat:'Y-m-d'}} 
                               className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                               placeholder={t('booking.date_out')} 
                               onChange={(dates) =>{
                                 setEndDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                               }} />
                  </div>
             </div>
           <div>
            {!isPhnomPenh ? (
              <>
              <div className="d-flex justify-content-center align-items-center" style={{ gap: 15, background: "#fff", padding: "12px 20px", borderRadius: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "fit-content", margin: "20px auto" }} >
               <div style={{ fontSize: 18, fontWeight: 600, color: "#333" }}>Currency</div>
               {/* VND */}
               <label htmlFor="vnd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: 0, background: currency === "VND" ? "#482979" : "#f5f5f5", color: currency === "VND" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
                 <input
                   type="radio"
                   id="vnd"
                   value="VND"
                   checked={currency === "VND"}
                   onChange={(e) =>
                     setCurrency(e.target.value)
                   }
                   style={{ display: "none" }}
                 />
                 ₫ VND
               </label>
               <label htmlFor="usd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginLeft: 0, background: currency === "USD" ? "#482979" : "#f5f5f5", color: currency === "USD" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
                 <input
                   type="radio"
                   id="usd"
                   value="USD"
                   checked={currency === "USD"}
                   onChange={(e) =>
                     setCurrency(e.target.value)
                   }
                   style={{ display: "none" }}
                 />
                 $ USD
               </label>
   
             </div>
             <div style={{fontSize: 20, fontWeight: 'bold',color: "#482979"}}>Rate: 1$ = {Intl.NumberFormat("de-DE", { style: "currency", currency: "VND" }).format(usdRate)}</div>
               <div style={{fontSize: 15, fontWeight: 'bold',color: "#000"}}>Last Updated: {new Date(timeLastUpdated).toLocaleString()}</div>
              </>
            ): (<></>)}
           </div>
               </div> 
           </div>
          
              </div>
      {isLoading && (
           <LoadingModal />
          )}
              
     {data && (
      <div>
         <div className="d-flex align-items-center" style={{marginTop: 20}}>
            <img src="https://cdn-icons-png.flaticon.com/512/11357/11357220.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
        <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Market Analytic Report</div>
        </div>
       <div className="container-fluid">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex mt-5">
                                      <div style={{marginRight: 10, width: 'fit-content'}}>
                                            <select className={styles.contentBookingBranchSelect} value={branchLocation} onChange={(e) => {
                                              setBranchLocation(e.target.value) 
                                              }}>
                                                {hotelBbox.map((item, idx) => (
                                                    <option key={idx} value={item.bbox}> {item.name} </option>
                                                  ))}
                                                  </select>
                                            </div>
                                      {/* <div style={{marginRight: 10, width: 'fit-content'}}>
                                            <select className={styles.contentBookingBranchSelect} value={orderBy} onChange={(e) => {
                                              setOrderBy(e.target.value) 
                                              }}>
                                                {hotelOrder.map((item, idx) => (
                                                    <option key={idx} value={item.value}> {item.name} </option>
                                                  ))}
                                                  </select>
                                            </div> */}
                                      <div style={{marginRight: 10, width: 'fit-content'}}>
                                            <div style={paginationContainerStyle}>
                                                  <button
                                                    onClick={() => setOffset(prev => Math.max(prev - 20, 0))}
                                                    disabled={offset === 0}
                                                    style={{
                                                      ...paginationBtnStyle,
                                                      ...(offset === 0 && paginationBtnDisabledStyle),
                                                    }}
                                                  >
                                                    «
                                                  </button>

                                                  <span style={paginationTextStyle}>
                                                    Page {Math.floor(offset / 20) + 1} of 5
                                                  </span>

                                                  <button
                                                    onClick={() => setOffset(prev => prev + 20)}
                                                    disabled={offset + 20 >= 100} // Assuming 100 is the max offset for demo
                                                    style={{
                                                      ...paginationBtnStyle,
                                                      ...(offset + 20 >= 100 && paginationBtnDisabledStyle)
                                                    }}
                                                  >
                                                    »
                                                  </button>
                                                </div>
                                            </div>

                                  </div>
                               <div className="d-flex flex-wrap align-items-center" style={{ gap: 16, marginTop: 10, }} >
                                    <div style={{ background: "#fff", padding: "14px 22px", borderRadius: 16, boxShadow: "0 4px 12px rgba(0,0,0,0.08)", minWidth: 220, border: "1px solid #f0f0f0", }} >
                                      <div style={{ fontSize: 14, color: "#888", marginBottom: 6, fontWeight: 500, }} > Average Price </div>
                                      <div style={{ fontSize: 28, fontWeight: 700, color: "#2b6cb0", }} >{Intl.NumberFormat("de-DE", { maximumFractionDigits: 0, }).format(CurrencyConverter(data?.averagePrice, currency, usdRate))} {currencyAPI}</div> 
                                      </div>

                                    <div style={{ background: "#fff", padding: "14px 22px", borderRadius: 16, boxShadow: "0 4px 12px rgba(0,0,0,0.08)", minWidth: 220, border: "1px solid #f0f0f0", }} >
                                      <div style={{ fontSize: 14, color: "#888", marginBottom: 6, fontWeight: 500, }} > Lowest Price </div>
                                      <div style={{ fontSize: 28, fontWeight: 700, color: "#38a169", }} >{Intl.NumberFormat("de-DE", { maximumFractionDigits: 0, }).format(CurrencyConverter(data?.lowestPrice, currency, usdRate))} {currencyAPI}</div> 
                                      </div>

                                    <div style={{ background: "#fff", padding: "14px 22px", borderRadius: 16, boxShadow: "0 4px 12px rgba(0,0,0,0.08)", minWidth: 220, border: "1px solid #f0f0f0", }} >
                                      <div style={{ fontSize: 14, color: "#888", marginBottom: 6, fontWeight: 500, }} > Highest Price </div>
                                      <div style={{ fontSize: 28, fontWeight: 700, color: "#e53e3e", }} >{Intl.NumberFormat("de-DE", { maximumFractionDigits: 0, }).format(CurrencyConverter(data?.highestPrice, currency, usdRate))} {currencyAPI}</div>
                                    </div>
                                  </div>
                                  </div>
 <table style={{...tableStyle}}>
          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.pagePath')} data-for="marketing">No.</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.pagePath')} data-for="marketing">Hotel Name</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">Address</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">Distance (km)</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">To City Center (km)</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">Check In</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">Check Out</th>
              {branchLocation === "16.0409,16.1309,108.1610,108.2690" && (
                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">Beach View</th>
              )}
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.country')} data-for="marketing">Price</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.device')} data-for="marketing">Type</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.browser')} data-for="marketing">Breakfast</th>
              {/* <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.os')} data-for="marketing">Review</th> */}
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.os')} data-for="marketing">URL</th>
            </tr>
          </thead>

          <tbody>
            {sortData.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                <td style={tdStyle}>{idx+1}</td>
                <td style={{...tdStyle, textAlign: 'left'}}>{item.hotelName}</td>
                <td style={{...tdStyle, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 400}}>{item.address}</td>
                <td style={tdStyle}>{item.distance}</td>
                <td style={tdStyle}>{item.distanceToCC}</td>
                <td style={tdStyle}>{item.checkin}</td>
                <td style={tdStyle}>{item.checkout}</td>
                 {branchLocation === "16.0409,16.1309,108.1610,108.2690" && (
                <td style={tdStyle}>{item.beach === 1 ? <i class="fa-solid fa-check" style={{color: 'green'}}></i> : <i class="fa-solid fa-xmark" style={{color: 'red'}}></i>}</td>
                 )}
                 {currencyAPI === "USD" ? (
                  <td style={tdStyle}>{Intl.NumberFormat('en-US').format(item.price)} {currencyAPI}</td>
                 ) : (
                <td style={tdStyle}>{Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(CurrencyConverter(item.price, currency, usdRate))} {currencyAPI}</td>
                 )}
                <td style={tdStyle}>{item.hotelType}</td>
                <td style={tdStyle}>{item.breakfast === 1 || item.breakfast ? <i class="fa-solid fa-check" style={{color: 'green'}}></i> : <i class="fa-solid fa-xmark" style={{color: 'red'}}></i>}</td>
                {/* <td style={tdStyle}>{Number.isInteger(item.review) ? `${item.review}.0` : item.review} <i class="fa-solid fa-star" style={{color: "yellow"}}></i></td> */}
                <td style={tdStyle}><a href={item.url} target="_blank" rel="noopener noreferrer"> Link </a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div> 
 </div>
      )}

    </div>
  );
}
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  borderRadius: 16,
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  backgroundColor: "#fff",
  tableLayout: "auto",
  marginTop: 10
};
const thStyle = {
  padding: "14px 16px",
  textAlign: "center",
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: "0.5px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  fontSize: 18,
  color: "#333",
  backgroundColor: "#fff",
  cursor: "pointer",
  whiteSpace: "nowrap", 
};
const stickyHeader = {
  fontSize: 16,
  position: 'sticky',top: 80,
  zIndex: 999
};

const paginationContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 14,
  width: "fit-content",
  padding: "10px 16px",
  borderRadius: 16,
  background: "#fff",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
};

const paginationBtnStyle = {
  height: 42,
  width: 42,
  border: "none",
  borderRadius: 12,
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.25s ease",
  boxShadow: "0 4px 10px rgba(108, 74, 182, 0.25)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const paginationBtnDisabledStyle = {
  background: "#f3f4f6",
  color: "#9ca3af",
  cursor: "not-allowed",
  boxShadow: "none",
};

const paginationTextStyle = {
  fontSize: 16,
  fontWeight: 600,
  color: "#482979",
  whiteSpace: "nowrap",
};




